import { logException } from "./logging";

// Only same-origin relative paths and absolute http(s) URLs may drive a navigation. Any other
// scheme (javascript:, data:, vbscript:, file:, blob:, mailto:, ...) can execute script or exfiltrate
// in the destination context, and a protocol-relative "//host" URL escapes the current origin - all
// are rejected. Absolute http(s) URLs stay allowed because the invoice payment flow legitimately
// redirects to server-issued payment links.
export const isSafeRedirectUrl = (url: string): boolean => {
    if (typeof url !== "string") return false;

    const trimmed = url.trim();
    if (trimmed.length === 0) return false;

    // Protocol-relative ("//evil.com") resolves to a foreign origin - reject before the path check.
    if (trimmed.startsWith("//")) return false;

    // Same-origin relative paths (including query-only "?..." fragments) are safe.
    if (trimmed.startsWith("/") || trimmed.startsWith("?")) return true;

    try {
        const parsed = new URL(trimmed, window.location.origin);
        return parsed.protocol === "http:" || parsed.protocol === "https:";
    } catch {
        // Malformed URL - treat as unsafe.
        return false;
    }
}

export const redirectTo = (url: string): void => {
    if (!isSafeRedirectUrl(url)) {
        logException(new Error(`Blocked navigation to unsafe redirect URL: ${url}`));
        return;
    }
    window.location.href = url;
}
